export enum Area {
  Domestic = 'domestic',
  International = 'international',
}
